import { IModel, Service } from '../../types';
import { buildServiceUrls } from './serviceUrlBuilder';

/**
 * Builds a {@link microsoftTeams.settings.Settings} object based on
 * project, service and connection information. It is used in a new
 * Teams tab creation.
 *
 * @returns
 * {microsoftTeams.settings.Settings} {@link microsoftTeams.settings.Settings} object
 */
export async function buildTeamsSettings(
  tabName: string,
  projectId: string,
  service: Service,
  defaultRoute?: string,
  connectionId?: string,
  connectionName?: string,
  iModel?: IModel
): Promise<microsoftTeams.settings.Settings> {
  const serviceRoute = defaultRoute ? `/${defaultRoute}` : '';
  let url =
    `${location.origin}/tab-content/${service?.id}/` +
    `${projectId}${serviceRoute}?theme={theme}`;

  if (connectionName) {
    url += `&connectionName=${connectionName}`;
  }

  const removalUrl = `${location.origin}/team-tab-removal?theme={theme}`;
  const { linkToUrl } = await buildServiceUrls({
    projectId,
    service,
    connectionId,
    defaultRoute,
    iModel,
  });

  const entityId = getConcatenatedEntityId(
    projectId,
    service,
    defaultRoute,
    connectionId,
    iModel
  );

  return {
    contentUrl: url,
    websiteUrl: linkToUrl,
    entityId,
    suggestedDisplayName: tabName,
    removeUrl: removalUrl,
  };
}

const getConcatenatedEntityId = (
  projectId: string,
  service?: Service,
  defaultRoute?: string,
  connectionId?: string,
  iModel?: IModel
): string => {
  let entityId = `${projectId}--${service?.id}`;

  if (iModel?.iModelId && iModel?.namedVersionId && iModel?.defaultViewId) {
    entityId += `--${iModel?.iModelId}--${iModel?.namedVersionId}--${iModel?.defaultViewId}`;
  } else if (connectionId) {
    entityId += `--${connectionId}`;
  } else if (defaultRoute) {
    entityId += `--${defaultRoute}`;
  }

  return entityId;
};
